import { type FetchResponse } from '@sydle/ui-api';
import { getApp } from '@sydle/ui-utils';
import { blogCustomAPI } from './index';

export interface downloadRichContentInput {
  appIdentifier?: string;
  postId: string;
  lang?: string;
}

export async function downloadRichContent(input: downloadRichContentInput): Promise<FetchResponse<Blob>> {
  input.appIdentifier = getApp()?.identifier;

  const response = await blogCustomAPI.fetch<downloadRichContentInput, Blob>(
    'downloadRichContent',
    {
      ...input,
    },
    {
      requestParams: { responseContentType: 'blob' },
    },
  );

  return response;
}
